import type { FC } from "react";
import { useEffect } from "react";
import { Image } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

import { Lightbox } from "components/Lightbox";

import { useClassroomAmbienceContext } from "features/ClassroomAmbience/context";

import { gtmExercisePaused } from "utils/gtmEvents";

interface Props {
  onClose: () => void;
  onQuit: () => void;
  isSoundToggleVisible?: boolean;
  continueButtonText?: string;
  quitButtonText?: string;
}

const PauseModal: FC<Props> = ({
  onClose,
  onQuit,
  isSoundToggleVisible = true,
  continueButtonText,
  quitButtonText,
}) => {
  const { isSoundOn, onToggleSound } = useClassroomAmbienceContext();

  const { t } = useTranslation(["common", "exercise"]);

  useEffect(() => {
    gtmExercisePaused();
  }, []);

  return (
    // AIDEV-NOTE: Žádný nadpis v obsahu — hlavička zůstává holá. Přístupné jméno bere
    // `exercise:header.paused` ("Pozastaveno"), který v kódu jinak nikde nebyl zapojený.
    // Jde přes `ariaLabel`, ne `title`, aby se text nezobrazil v hlavičce a nezměnil
    // vzhled bez potvrzení návrhem. Zadavatel ať posoudí, jestli má klíč patřit rovnou
    // do hlavičky. [TD-344]
    <Lightbox show={true} onHide={onClose} bodyClassName="pb-40px" ariaLabel={t("header.paused", { ns: "exercise" })}>
      <div className="mb-8px text-center">
        <Image src={"/images/capy-paused.svg"} />
      </div>
      <div className={"d-grid gap-8px"}>
        {isSoundToggleVisible ? (
          <Button variant="outline-success" className={"w-100 text-uppercase"} onClick={onToggleSound}>
            {t(isSoundOn ? "btn.turnSoundOff" : "btn.turnSoundOn", { ns: "exercise" })}
          </Button>
        ) : null}
        <Button variant="success" className={"w-100 text-uppercase"} onClick={onClose}>
          {continueButtonText ?? t("btn.continueFurther", { ns: "exercise" })}
        </Button>
      </div>
      <p className={"text-center my-20px"}>{t("or", { ns: "common" })}</p>
      <Button variant="outline-danger" className={"w-100 text-uppercase"} onClick={onQuit}>
        {quitButtonText ?? t("btn.exerciseEnd", { ns: "exercise" })}
      </Button>
    </Lightbox>
  );
};

export default PauseModal;
